<template>
  <div class="message-view">
    <div class="message-top-view" style="height: 60px">
      <span class="message-top-title">{{$t("ctMessage.message")}}</span>
    </div>
    <div class="message-configure-view">
      <span class="notice-title">{{ $t("ctMessage.notificationType") }}</span>
      <span class="message-notificaiton-choose">
        <el-checkbox-group class="notification-group" v-model="notificationSelected" @change="typeChange">
          <el-checkbox v-for="city in typeList" :label="city.value" :key="city.value">{{city.label}}</el-checkbox>
        </el-checkbox-group>
      </span>

      <span class="message-readStatus">
        <span class="notice-title">{{ $t("ctMessage.notificationStatus") }}</span>
        <el-checkbox-group class="notification-group" v-model="readStatus" @change="statusChange">
          <el-checkbox v-for="city in statusList" :label="city.value" :key="city.value">{{city.label}}</el-checkbox>
        </el-checkbox-group>
      </span>
    </div>

    <ul class="message-content-view">
      <li v-for="(item,index) in messageList" :key="index" :class="item.messageStatus == 1 ? 'readed':''"  @click="onClickFile(item)">
        <i class="dot"></i>
        <div class="message-top-view">
          <span class="type-name">{{item.typeMoldStr}}</span>
          <span class="message-top-time">{{item.createTime}}</span>
        </div>
        <p v-html="item.messageContent"></p>
<!--        <div class="message-bottom-view">-->
<!--          <span class="content-bottom-right" v-html="item.messageContent"></span>-->
<!--        </div>-->
      </li>
    </ul>
    <!-- 当列表数据为空时显示界面 -->
    <div
      class="statusEmpty"
      v-if="!messageList || !messageList.length"
    >
      <i></i>{{ $t("frontPage.noData") }}
    </div>
    <!-- 翻页 -->
    <div class="emailManagement-pagination-box">
      <el-pagination
        style="text-align:center; padding: 20px 5px"
        background
        layout="prev, pager, next"
        class="page-theme"
        :page-size="10"
        :total="total"
        :current-page.sync="pg_st"
        @current-change="getMessageList()"
        v-if="messageList && messageList.length"
      ></el-pagination>
    </div>


  </div>
</template>

<script>
export default {
  name:'messageCenter',
  data(){
    return{
      messageList:[],
      notificationSelected:['T10004','T10002'],
      typeList:[
        {
          value: 'T10004',
          label: this.$t('ctMessage.financeNews')
          // label: this.$t('ctMessage.messageType1')
        },{
          value: 'T10002',
          // label: '系统消息'
          label: this.$t('ctMessage.systemNews')
        },
      ],

      readStatus:[0,1],
      statusList:[
        {
          value: 1,
          // label: '已读'
          label: this.$t('ctMessage.hasRead')
        },{
          value: 0,
          // label: '未读'
          label: this.$t('ctMessage.unRead')
        }
      ],
      messageListItemBackgroundColor:'#f8fafd',

      // 当前页码
      pg_st: 1,
      total: 0,
    }
  },
  created() {
    //获取消息列表
    this.getMessageList()
  },
  mounted() {
    document.title = this.$t('ctMessage.message');
  },
  methods:{
    //更新了接收消息类型、阅读状态，自动请求消息列表
    typeChange(){
      this.pg_st=1
      this.getMessageList()
    },

    statusChange(){
      this.pg_st=1
      this.getMessageList()
    },

    //获取消息列表
    getMessageList(){
      let _this = this
      let param = {
        typeList:_this.notificationSelected,
        statusList:_this.readStatus,
        rows:10,
        page:_this.pg_st
      }
      this.axios.post("/api/zma/msg/getList", param).then(res => {
        console.log("获取消息列表");
        console.log(res);
        if (res.status) {
          // _this.messageList = res.data.data;
          _this.timeChangeToMessageList(res.data['data'])
          _this.total = res.data.count;
        } else {
          _this.$message.error(this.$t(`poolOfMoney_error.${res.errorCode}`));
        }
      });
    },

    //进行时间戳转化
    timeChangeToMessageList(data){
      var tempMessgeList = [];
      if (data.length > 0){
        for (let i = 0; i < data.length; i++){
          let item = data[i]
          let itemTime = item['createTime']

          var monthArr = new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec");
          var time = new Date(itemTime); // 需要使用Date格式进行日期转化，若是时间戳、字符串时间，需要通过new Date(..)转化

          var y = time.getFullYear();
          var month = monthArr[time.getMonth()]; //月
          var d = time.getDate();
          var h = time.getHours();
          var mm = time.getMinutes();
          item.createTime = h+':'+this.isZero(mm)+' '+this.isZero(d)+' '+month+','+y;
          tempMessgeList.push(item)
        }
      }
      this.messageList = tempMessgeList
    },

    isZero(m){
      return m<10 ? ('0'+m):m
    },

    //点击消息
    onClickFile(item){
      let _this = this
      if (item.messageStatus == 0){
        //通知服务端消息已读

        //接口通知服务端，已读该消息
        let param = {
          msgCode:item.msgCode
        }
        _this.axios.post('/api/zma/msg/readMessage',param).then(res=> {
          console.log(res);
          console.log('通知服务端已读成功，并更新列表数据')
          _this.getMessageList()
        }).catch(res=>{
          _this.$message.error(this.$t(`poolOfMoney_error.${res.errorCode}`));
        });
      }



      //跳转
      if (!item.businessCode || !item.businessCode < 0){
        console.log('没有流水单号，是系统通知')
        return
      }
      //businessCode是流水单号，获取详情后跳转
      let params = {
        flowNumber:item.businessCode
      }
      this.axios.post("/api/zma/financing/getZmaFinancingStatusByFlowNumber", params).then(res => {
        console.log("获取订单当前状态");
        console.log(res);
        if (res.status) {
          let sortItem = res.data[0]
          _this.jumpToDetailByStatus(sortItem['status'], item)
        } else {
          _this.$message.error(this.$t(`poolOfMoney_error.${res.errorCode}`));
        }
      });

    },

    jumpToDetailByStatus(status, item){
      console.log('status================'+status)
      if ([102, 103, 104, 105, 106, 108, 109, 110, 111, 113, 120, 140, 150, 160, 170, 180].indexOf(status) > -1){
        console.log('跳转item.flowNumber========='+item.businessCode)
        this.$router.push(
          {
            path: '/loanDetail',
            query: {f_n:item.businessCode, menuType:6}
          }
        )
      }else if ([1,2,3,4,5,6,7,8].indexOf(status) > -1){
        this.$router.push(
          {
            path: '/rongzisqs',
            query: {id:item.businessCode, menuType:1}
          }
        )
      }else if ([10,11,12,13,14,300].indexOf(status) > -1){
        //资金锁定详情
        this.$router.push(
          {
            path: '/financingFundDetail',
            query: {in_id:item.businessCode, menuType:6}
          }
        )
      }else if ([15,17,18,19,20,21,22].indexOf(status) > -1){
        this.$router.push(
          {
            path: '/financingExamineDetail',
            query: {in_id:item.businessCode, menuType:6}
          }
        )
      }
    },
  }
}
</script>

<style lang="scss">
.message-view{
  font-size: 14px;
  //height: 900px;
  background-color: #FFFFFF;
  //margin-bottom: 50px;
  .message-top-view{
    width: 100%;
    //background-color: white;
    //height: 60px;
    display: flex;
    .message-top-title{
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      margin-left: 28px;
      margin-top: 19px;
      font-weight: bold;
    }
  }
  .message-configure-view{
    background-color: #ffffff;
    height: 60px;
    display: flex;
    border-top: 1px solid #EAEAEA;
    .notice-title{
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      align-self: center;
      margin-left: 28px;
      margin-right: 14px;
    }
    .message-notificaiton-choose{
      //width: 360px;
      height: 100%;
      display: flex;
    }
    .message-readStatus{
      width: 360px;
      height: 100%;
      margin-left: 60px;
      display: flex;
    }
    .notification-group {
      margin-top: 20px;
    }
  }

  .message-content-view{
    background-color: #FFFFFF;
    padding: 0 28px;
    li{
      background-color: #eef3fa;
      border-bottom: 1px solid #EEEEEE;
      padding: 20px 20px 20px 30px;
      position: relative;
      .dot{
        position: absolute;
        background: #E44245;
        width: 10px;
        height: 10px;
        border-radius: 10px;
        left: 8px;
        top: 8px;
      }
      .type-name {
        text-align: center;
        width: 48px;
        height: 18px;
        font-size: 12px;
        line-height: 18px;
        background-color: #7996f5;
        color: #FFFFFF;
        border-radius: 2px;
      }

      .message-top-time {
        color: #999999;
        font-size: 12px;
        margin-left: 10px;
        line-height: 18px;
      }
      p{
        padding-top: 10px;
        color: #333333;
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
      }

      &.readed{
        background-color: #f8fafd;
        .dot{
          display: none;
        }
        p{
          color: #666666;
          font-weight: normal;
        }
        &:hover{
          background-color: #eef3fa;
        }
      }
      &:hover{
        background-color: #eef3fa;
        cursor: pointer;
      }
    }


  }

  .emailManagement-pagination-box{
    //margin-top: 28px;
    //margin-bottom: 20px;
  }


}
</style>
